import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20stage%20with%20dramatic%20warm%20golden%20spotlight%20and%20theater%20curtains%2C%20elegant%20film%20premiere%20atmosphere%2C%20luxurious%20red%20and%20gold%20decor%2C%20professional%20cinema%20photography%2C%20soft%20bokeh%20lights%20in%20background%2C%20grand%20and%20magnificent%20mood&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="香蕉影视 - 综艺娱乐免费高清在线观看"
        title="香蕉影视综艺娱乐免费高清在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      <div className="absolute inset-0 flex items-center justify-center px-4 md:px-6">
        <div className="w-full max-w-4xl text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
            综艺娱乐免费高清在线观看
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed px-4">
            热门最新搞笑综艺大全，高清不缓冲流畅秒开不卡顿，全集免费看。轻松享受精彩综艺，随时随地想看就看。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/gaoxiao-zongyi"
              className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm md:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              热门综艺
            </Link>
            <Link
              to="/about"
              className="border-2 border-white/40 hover:border-white text-white px-8 py-3 rounded-full text-sm md:text-base font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-10 left-0 w-full">
        <div className="flex items-center justify-center gap-6 md:gap-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-primary-400">1000+</p>
            <p className="text-xs text-white/60 mt-1">热门综艺</p>
          </div>
          <div className="w-px h-8 md:h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-primary-400">8大</p>
            <p className="text-xs text-white/60 mt-1">综艺分类</p>
          </div>
          <div className="w-px h-8 md:h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading text-primary-400">4K</p>
            <p className="text-xs text-white/60 mt-1">高清画质</p>
          </div>
        </div>
      </div>
    </section>
  );
}